"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../core/table"));
var _input = _interopRequireDefault(require("../../core/input"));
var _helpButton = _interopRequireDefault(require("../../core/help-button"));
var _alert = _interopRequireDefault(require("../../core/alert"));
var _container = _interopRequireDefault(require("../../core/container"));
var _ageCategoriesHelp = _interopRequireDefault(require("./age-categories-help"));
var _ageCategoryRow = _interopRequireDefault(require("./age-category-row"));
var _sortableRowsContainer = _interopRequireDefault(require("../../core/sortable-rows-container"));
var _reactSortableHoc = require("react-sortable-hoc");
var _addAgeCategory = _interopRequireDefault(require("./add-age-category"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SortableAgeCategoryRow = (0, _reactSortableHoc.SortableElement)(_ageCategoryRow.default);
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_ageCategoriesHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement(_addAgeCategory.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, "Changes to the age categories will impact new non-ranked paddlers but will not change existing entries.");
var _ref5 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref6 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Sort"), /*#__PURE__*/_react.default.createElement("th", null, "ID"), /*#__PURE__*/_react.default.createElement("th", null, "Description"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Default Category"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Minimum Age"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Maximum Age")));
class AgeCategories extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onSort", ageCategories => {
      this.props.sortAgeCategories(ageCategories.map(refCode => refCode.id));
    });
  }
  render() {
    const ageCategorySets = [{
      setName: 'Current Age Categories',
      ageCategories: this.props.ageCategories.filter(cat => !cat.isExpired)
    }, {
      setName: 'Expired Age Categories',
      ageCategories: this.props.ageCategories.filter(cat => cat.isExpired)
    }];
    return /*#__PURE__*/_react.default.createElement(_container.default, null, _ref, _ref2, _ref3, _ref4, ageCategorySets.map(ageCategorySet => /*#__PURE__*/_react.default.createElement("div", {
      key: ageCategorySet.setName
    }, _ref5, /*#__PURE__*/_react.default.createElement("h5", {
      key: ageCategorySet.setName
    }, ageCategorySet.setName), !ageCategorySet.ageCategories.length ? /*#__PURE__*/_react.default.createElement("p", null, ageCategorySet.setName === 'Expired Age Categories' ? 'No age categories have been expired' : 'No Age Categories') : /*#__PURE__*/_react.default.createElement(_table.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_sortableRowsContainer.default, {
      items: ageCategorySet.ageCategories,
      onSort: this._onSort
    }, /*#__PURE__*/_react.default.createElement("tbody", null, ageCategorySet.ageCategories.map((ageCategory, index) => /*#__PURE__*/_react.default.createElement(SortableAgeCategoryRow, {
      key: ageCategory.id,
      index: index,
      ageCategory: ageCategory
    }))))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref7 = {
  ageCategories: {
    id: true,
    description: true,
    sortOrder: true,
    isExpired: true,
    isDefault: true,
    minAge: true,
    maxAge: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(AgeCategories, props => _ref7, (client, props) => ({
  sortAgeCategories(ageCategoryIDs) {
    return client.update('AgeCategory.sort', {
      ageCategoryIDs
    });
  }
}));